import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
var LearningMapIntroductionComponent = (function () {
    function LearningMapIntroductionComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        // @Input() learningPath :  any
        this.onButtonClick = new EventEmitter();
    }
    LearningMapIntroductionComponent.prototype.ngOnInit = function () {
        this.commonService.initPage({
            backgroundColor: 'white'
        });
        window['s2j_onPlayOver'] = function () {
            $('#video-intro').fadeOut(200);
            $('.closeBtn').click();
            $('.closeBtn').fadeOut(200);
            // $('#wrapAll').fadeIn(200);
        };
        console.log(123);
    };
    LearningMapIntroductionComponent.prototype.ngAfterViewInit = function () {
        var player = polyvPlayer({
            wrap: '#video-intro',
            width: '100vw',
            height: '100vh',
            vid: '352e2664d8ac0401e9e2b433d7dd7ca5_3',
            // autoplay: true,
            // skinLocation: 0,
            ban_history_time: 'on',
            // hideSwitchPlayer: true,
            hideRepeat: true,
            // forceH5: true,
            flashvars: { 'autoplay': true }
            // audioMode: false
        });
        player.toggleFullscreen();
    };
    LearningMapIntroductionComponent.prototype.onBtnClick = function () {
        this.onButtonClick.emit();
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/learningtour/guidePageShown'
        }).subscribe(function (result) { });
    };
    return LearningMapIntroductionComponent;
}());
export { LearningMapIntroductionComponent };



// WEBPACK FOOTER //
// ./src/app/learning-map-introduction/learning-map-introduction.component.ts.pre-build-optimizer.js